import { Route, Routes } from "react-router-dom";
import { Layout } from "../components/templates/layout";
import Appointment from "../modules/appointment/appointment";
import Login from "../modules/authentication/login";
import Profile from "../modules/profile/profile";
import VehicleInspectionList from "../modules/vehicleInspection/vehicleInspection";
import PrivateRoute from "./privateRoute";
import PageNotFoundComponent from "../components/templates/PageNotFoundComponent";
import CreateAppointmentIndex from "../modules/appointment/appointmentCreate/createAppointment.index";
import AppointmentDetailsComponent from "../modules/appointment/appointmentDetails";
import TaskDetailsAppointment from "../modules/appointment/taskDetailsAppointment";
import FinalInspector from "../modules/finalInspector/finalInspector";
import FinalInspectorTaskDetails from "../modules/finalInspector/finalInspectorTaskDetails/finalInspectorTaskDetails";
import ServiceEstimate from "../modules/serviceEstimate/serviceEstimate";
import CreateEstimateIndex from "../modules/serviceEstimate/serviceEstimateCreate/createEstimate.index";
import EstimateDetailsIndex from "../modules/serviceEstimate/serviceEstimateDetails/estimateDetails.index";
import ServiceEstimateCreateStatus from "../modules/serviceEstimate/serviceEstimateDetails/serviceEstimate.createStatus";
import TaskDetailsEstimate from "../modules/serviceEstimate/taskDetailsEstimate";
import { DemoForm } from "../builderPackage/example/demoForm";
import NewDashboard from "../modules/dashboard/newDashboard/newDashboard";
import { VehicleModule } from "../modules/dashboard/newDashboard/vehicleModuleDash";
import AddNewJobsBajaj from "../modules/jobCard/revisedEstimate/addNewJobsBajaj";
import AddNewJobsProduct from "../modules/jobCard/revisedEstimate/addNewJobsProduct";
import JournalVoucher from "../modules/journalVoucher/pages/JournalVoucher";
import { CreateJournalVoucher } from "../modules/journalVoucher/pages/createJournalVoucher";
import PermalinkForm from "../modules/reports/Reports";
import { CreateSpareIssues } from "../modules/spareIssue/pages/createSpareIssues";
import SpareIssues from "../modules/spareIssue/pages/spareIssues";
import { CreteStockAdjustment } from "../modules/stockAdjustment/pages/createStockAdjustment";
import { StockAdjustmentList } from "../modules/stockAdjustment/pages/stockAdjustmentList";
import CreateInspectionIndex from "../modules/vehicleInspection/InspectionCreate/createInspection.index";
import DocumentConversionIndex from "../modules/vehicleInspection/documentConversionIndex";
import InspectionDetailsComponent from "../modules/vehicleInspection/inspectionDetails";
import TaskDetailsVehicleInspection from "../modules/vehicleInspection/taskDetailsVehicleInspection";
import { Module, isModuleConfig } from "../constants";
import { BranchToBranchInwardList } from "../modules/branchToBranchInward/pages/branchToBranchInwardList";
import CreateBranchToBranchInward from "../modules/branchToBranchInward/pages/createBranchToBranchInward";
import { BranchToBranchRequisitionList } from "../modules/branchToBranchRequisition/pages/branchToBranchRequisitionList";
import { CreateBranchToBranchRequisition } from "../modules/branchToBranchRequisition/pages/createBranchToBranchRequisition";
import { CreatePurchaseOrder } from "../modules/purchaseOrder/pages/createPurchaseOrder";
import { PurchaseOrderList } from "../modules/purchaseOrder/pages/purchaseOrderList";
import SparePartsDashboard from "../modules/spareParts/dashboard/sparePartsDashboard";
import CreateInterWarehouseInward from "../modules/spareParts/inventory/transfer/interWarehouseTransfer/interWarehouseInward/pages/createInterWarehouseInward";
import InterWarehouseInward from "../modules/spareParts/inventory/transfer/interWarehouseTransfer/interWarehouseInward/pages/interWarehouseInward";
import { CreateInterWarehouseRequisition } from "../modules/spareParts/inventory/transfer/interWarehouseTransfer/interWarehouseStockTransferRequisition/pages/createInterWarehouseRequisition";
import InterWarehouseRequisition from "../modules/spareParts/inventory/transfer/interWarehouseTransfer/interWarehouseStockTransferRequisition/pages/interWarehouseRequisition";
import { CreatePurchaseRequisition } from "../modules/spareParts/purchaseRequistion/pages/createPurchaseRequisition";
import PurchaseRequisition from "../modules/spareParts/purchaseRequistion/pages/purchaseRequisition";
import { CreateStockTransfer } from "../modules/stockTransfer/pages/createStockTransfer";
import { StockTransferList } from "../modules/stockTransfer/pages/stockTransferList";
import { CreateStockTransferRequisition } from "../modules/stockTransferRequistion/pages/createStockTransferRequisition";
import { StockTransferRequisitionList } from "../modules/stockTransferRequistion/pages/stockTransferRequisitionList";
import { CreateWarehouseOutward } from "../modules/warehouseOutward/pages/createInterWarehouseOutword";
import { WarehouseOutwardList } from "../modules/warehouseOutward/pages/interWarehouseOutword";
import ServiceHistory from "../../src/modules/appointmentV3/components/serviceHistry";
import DemoCatalog from "../builderPackage/example/demoCatalog";
import JsonRenderer from "../builderPackage/example/jsonRenderer";
import AppointmentDetail from "../modules/appointmentV3/pages/appointmentDetail";
import CreateAppointment from "../modules/appointmentV3/pages/createAppointment";
import ContractSaleinvoice from "../modules/contractSaleInvoice/contractSaleinvoice";
import NewContractSaleInvoice from "../modules/contractSaleInvoice/newContractSaleInvoice";
import ContractSaleOrder from "../modules/contractSaleOrder/pages/contractSaleOrder";
import NewContractSaleOrder from "../modules/contractSaleOrder/pages/newContractSaleOrder";
import CrmCustomerProfile from "../modules/crm/dashboard/crmCustomerProfile";
import CRMDashboard from "../modules/crm/dashboard/crmDashboard";
import { AsmDashBoard } from "../modules/fieldFailureReport/ASM/Dasboard.ASM";
import ReceivedAFRs from "../modules/fieldFailureReport/PSG/pages/receivedAFRs";
import { FFrDashboard } from "../modules/fieldFailureReport/fieldFailureReport.dashBoard";
import { EditFieldFailureReport } from "../modules/fieldFailureReports/pages/editFieldFailureReport";
// import { JCiReturn } from "../modules/jciReturn/pages/jciReturn";
import { JciReturnUpdate } from "../modules/jciReturn/pages/jciReturnUpdate";
import JobCardDetailsM3 from "../modules/jobCardDetails/pages/jobCardDetailsM3";
import { AccountPostingMobile } from "../modules/jobcardInvoices/component/jobCardInvoice.accountPostingMobile";
import { ReadyForInvoiceMobile } from "../modules/jobcardInvoices/component/jobCardInvoice.readyForInvoiceMobile";
import JobCardInvoiceTabs from "../modules/jobcardInvoices/component/jobCardInvoiceTabs";
import { CreateInvoice } from "../modules/jobcardInvoices/pages/createInvoice";
import { InvoicedTab } from "../modules/jobcardInvoices/pages/invoicedTab";
import { PartInvoiceDetails } from "../modules/jobcardInvoices/pages/part.invoiceDetails";
import ReadyForInvoiceList, { ReadyForInvoiceTab } from "../modules/jobcardInvoices/pages/readyForInvoiceTab";
import { CreatePropritaryWarrantyIndex } from "../modules/proprietaryWarranty/pages/createProprietaryWarranty.index";
import ProprietaryWarranty from "../modules/proprietaryWarranty/pages/proprietaryWarranty";
import ServiceEstimateDetails from "../modules/serviceEstimateM3/pages/serviceEstimateDetails";
import CreateSpareIssueReturn from "../modules/spareIssueReturn/pages/createSpareIssueReturn";
import SpareIssueReturn from "../modules/spareIssueReturn/pages/spareIssueReturn";
import BranchToBranchOutward from "../modules/spareParts/inventory/branchToBranchTransfer/branchToBranchOutward/pages/branchToBranchOutward";
import CreateBranchToBranchOutward from "../modules/spareParts/inventory/branchToBranchTransfer/branchToBranchOutward/pages/createBranchToBranchOutward";
import CreateWorkPurchaseInvoice from "../modules/workPurchaseInvoice/pages/createWorkPurchaseInvoice";
import WorkPurchaseInvoice from "../modules/workPurchaseInvoice/pages/workPurchaseInvoice";
import { CreateWorkPurchaseOrder } from "../modules/workPurchaseOrder/pages/createWorkPurchaseOrder";
import { WorkPurchaseOrder } from "../modules/workPurchaseOrder/pages/workPurchaseOrderList";
// import ReceivedAFRs from "../modules/fieldFailureReport/PSG/pages/receivedAFRs";
// import { FFrDashboard } from "../modules/fieldFailureReport/fieldFailureReport.dashBoard";
// import { AsmDashBoard } from "../modules/fieldFailureReport/ASM/Dasboard.ASM";
import CreateNewPDICheck from "../modules/NewPDICheck/pages/createNewPDICheck";
import NewPDICheckPaging from "../modules/NewPDICheck/pages/newPDICheckPaging";
import ContractSalesReturnCreate from "../modules/contractSalesReturn/pages/contractSalesReturnCreate";
import ContractSaleReturn from "../modules/contractSalesReturn/pages/contractSalesReturnPaging";
import InvestigationReports from "../modules/fieldFailureReport/PSG/pages/IRs";
import { PSGDashboard } from "../modules/fieldFailureReport/PSG/pages/PSGDashboard";
import { UtilityCatalogView } from "../modules/fieldFailureReport/PSG/pages/UtilityCatalogView";
import EditAFR from "../modules/fieldFailureReport/PSG/pages/editAFR";
import EditIR from "../modules/fieldFailureReport/PSG/pages/editIR";
import { AddManualFieldFailureReport } from "../modules/fieldFailureReports/pages/addManualFieldFailureReport";
import FieldFailureReports from "../modules/fieldFailureReports/pages/fieldFailureReports";
import FieldFailureReport from "../modules/areaFieldReports/components/FFRs/components/FieldFailureReport";
import AreaFieldReport from "../modules/areaFieldReports/components/AFRs/components/AreaFieldReport";
import AreaFieldReports from "../modules/areaFieldReports/pages/areaFieldReports";
import { DashboardComp } from "../modules/areaFieldReports/components/dashboard/DashboardView";
// import AreaFieldReports from "../../../../../modules/areaFieldReports/pages/areaFieldReports";
// import AreaFieldReportsCreate from "../modules/areaFieldReports/components/FFRs/components/AreaFieldReportsCreate";
// import AreaFieldReports from "../modules/areaFieldReports/pages/areaFieldReports";
import NewJobCard from "../modules/jobCard/newJobcard/newJobCard";
import { VehicleHistory } from "../modules/vehicleHistory/pages/vehicleHistory";
import TabNavs from "./tabModules/tabNavs";
import { AreaFieldReportView } from "../modules/areaFieldReports/components/AFRs/areaFieldReportView";
import { FFRCatalog } from "../modules/areaFieldReports/components/FFRs/FFRCatalog";
import { CQADashboard } from "../modules/fieldFailureReport/CQA/pages/CQADashboard";
import CQA_IRs from "../modules/fieldFailureReport/CQA/pages/CQA_IRs";
import CQACorrectiveActionPlanned from "../modules/fieldFailureReport/CQA/pages/CQACorrectiveActionPlanned";
import CQAReceivedEdit from "../modules/fieldFailureReport/CQA/pages/CQAReceivedEdit";
import JciReturnNew from "../modules/jciReturn/pages/jciReturnNew";
import DialogDemo from "../builderPackage/example/renderEditPopup";
function AppRoutes() {
    return /*#__PURE__*/ React.createElement(Routes, null, /*#__PURE__*/ React.createElement(Route, {
        path: "/",
        element: /*#__PURE__*/ React.createElement(Login, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/",
        element: /*#__PURE__*/ React.createElement(PrivateRoute, null)
    }, /*#__PURE__*/ React.createElement(Route, {
        element: /*#__PURE__*/ React.createElement(Layout, null)
    }, /*#__PURE__*/ React.createElement(Route, {
        path: "*",
        element: /*#__PURE__*/ React.createElement(PageNotFoundComponent, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/dashboard",
        element: /*#__PURE__*/ React.createElement(NewDashboard, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/profile",
        element: /*#__PURE__*/ React.createElement(Profile, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/vehicle",
        element: /*#__PURE__*/ React.createElement(VehicleModule, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/appointment",
        element: /*#__PURE__*/ React.createElement(Appointment, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/Reports",
        element: /*#__PURE__*/ React.createElement(PermalinkForm, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/create-inspection",
        element: /*#__PURE__*/ React.createElement(CreateInspectionIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/inspection",
        element: /*#__PURE__*/ React.createElement(VehicleInspectionList, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/appointment-Detail/:id",
        element: /*#__PURE__*/ React.createElement(AppointmentDetailsComponent, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/inspection-Detail/:documentId",
        element: /*#__PURE__*/ React.createElement(InspectionDetailsComponent, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/jobCard",
        element: /*#__PURE__*/ React.createElement(NewJobCard, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/jobcard-details/:id",
        element: /*#__PURE__*/ React.createElement(JobCardDetailsM3, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/addNewJobs/:id",
        element: Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(AddNewJobsBajaj, null) : /*#__PURE__*/ React.createElement(AddNewJobsProduct, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/addNewJobs/:id/:preJobCardDocumentId",
        element: Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(AddNewJobsBajaj, null) : /*#__PURE__*/ React.createElement(AddNewJobsProduct, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/serviceEstimate",
        element: /*#__PURE__*/ React.createElement(ServiceEstimate, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/serviceEstimate-details/:documentId",
        element: /*#__PURE__*/ React.createElement(EstimateDetailsIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/serviceEstimate-details-jobCard/:documentId",
        element: /*#__PURE__*/ React.createElement(EstimateDetailsIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/reviseEstimate-details/:RevisedEstimate/:documentId/:jobCardId",
        element: /*#__PURE__*/ React.createElement(EstimateDetailsIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/serviceEstimate-details/:documentId/:inspection/:parentId",
        element: /*#__PURE__*/ React.createElement(EstimateDetailsIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/serviceEstimate-details-created/:documentId",
        element: /*#__PURE__*/ React.createElement(ServiceEstimateCreateStatus, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/serviceEstimate-create",
        element: /*#__PURE__*/ React.createElement(CreateEstimateIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/serviceEstimate-tasksDetails/:estimateId",
        element: /*#__PURE__*/ React.createElement(TaskDetailsEstimate, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/appoinment-tasksDetails/:appointmentId",
        element: /*#__PURE__*/ React.createElement(TaskDetailsAppointment, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/inspection-tasksDetails/:inspectionId",
        element: /*#__PURE__*/ React.createElement(TaskDetailsVehicleInspection, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/appointment-create",
        element: /*#__PURE__*/ React.createElement(CreateAppointmentIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/finalInspection",
        element: /*#__PURE__*/ React.createElement(FinalInspector, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/finalInspection-taskDetails/:jobCardId",
        element: /*#__PURE__*/ React.createElement(FinalInspectorTaskDetails, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/create-inspection/:documentId",
        element: /*#__PURE__*/ React.createElement(DocumentConversionIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/spareIssues",
        element: /*#__PURE__*/ React.createElement(SpareIssues, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/spareIssues/createSpareIssues",
        element: /*#__PURE__*/ React.createElement(CreateSpareIssues, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/spareIssues/createSpareIssues/:id",
        element: /*#__PURE__*/ React.createElement(CreateSpareIssues, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/spareIssues/createSpareIssues/:id/:tenantId",
        element: /*#__PURE__*/ React.createElement(CreateSpareIssues, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/spare-issue-return",
        element: /*#__PURE__*/ React.createElement(SpareIssueReturn, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createSpareIssueReturn",
        element: /*#__PURE__*/ React.createElement(CreateSpareIssueReturn, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/stockAdjustment",
        element: /*#__PURE__*/ React.createElement(StockAdjustmentList, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createStockAdjustment",
        element: /*#__PURE__*/ React.createElement(CreteStockAdjustment, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/stockTransferRequisition",
        element: /*#__PURE__*/ React.createElement(StockTransferRequisitionList, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createStockTransferRequisition",
        element: /*#__PURE__*/ React.createElement(CreateStockTransferRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createStockTransferRequisition/:id",
        element: /*#__PURE__*/ React.createElement(CreateStockTransferRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createPurchaseOrder",
        element: /*#__PURE__*/ React.createElement(CreatePurchaseOrder, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createPurchaseOrder/edit/:id",
        element: /*#__PURE__*/ React.createElement(CreatePurchaseOrder, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/purchaseOrder",
        element: /*#__PURE__*/ React.createElement(PurchaseOrderList, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/journalVoucher",
        element: /*#__PURE__*/ React.createElement(JournalVoucher, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/journalVoucher/createJournalVoucher",
        element: /*#__PURE__*/ React.createElement(CreateJournalVoucher, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/journalVoucher/createJournalVoucher/:id",
        element: /*#__PURE__*/ React.createElement(CreateJournalVoucher, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/spareParts/dashboard",
        element: /*#__PURE__*/ React.createElement(SparePartsDashboard, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/purchaseRequisition",
        element: /*#__PURE__*/ React.createElement(PurchaseRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/purchaseRequisition/createPurchaseRequisition",
        element: /*#__PURE__*/ React.createElement(CreatePurchaseRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/purchaseRequisition/createPurchaseRequisition/:id",
        element: /*#__PURE__*/ React.createElement(CreatePurchaseRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/stockTransfer",
        element: /*#__PURE__*/ React.createElement(StockTransferList, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createStockTransfer",
        element: /*#__PURE__*/ React.createElement(CreateStockTransfer, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/interWarehouseTransferRequisition",
        element: /*#__PURE__*/ React.createElement(InterWarehouseRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/interWarehouseTransferRequisition/createInterWarehouseTransfer",
        element: /*#__PURE__*/ React.createElement(CreateInterWarehouseRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/interWarehouseTransferRequisition/createInterWarehouseTransfer/:id",
        element: /*#__PURE__*/ React.createElement(CreateInterWarehouseRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/interWarehouseInward",
        element: /*#__PURE__*/ React.createElement(InterWarehouseInward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createInterWarehouseInward",
        element: /*#__PURE__*/ React.createElement(CreateInterWarehouseInward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/interWarehouseOutword",
        element: /*#__PURE__*/ React.createElement(WarehouseOutwardList, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createInterWarehouseOutward",
        element: /*#__PURE__*/ React.createElement(CreateWarehouseOutward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/warehouseOutword/edit/:id",
        element: /*#__PURE__*/ React.createElement(CreateWarehouseOutward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createStockTransfer/:id",
        element: /*#__PURE__*/ React.createElement(CreateStockTransfer, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/branchToBranchRequisition",
        element: /*#__PURE__*/ React.createElement(BranchToBranchRequisitionList, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createBranchToBranchRequisition",
        element: /*#__PURE__*/ React.createElement(CreateBranchToBranchRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createBranchToBranchRequisition/:id",
        element: /*#__PURE__*/ React.createElement(CreateBranchToBranchRequisition, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/branchToBranchOutward",
        element: /*#__PURE__*/ React.createElement(BranchToBranchOutward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/branchToBranchOutward/createBranchToBranchOutward",
        element: /*#__PURE__*/ React.createElement(CreateBranchToBranchOutward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/branchToBranchOutward/createBranchToBranchOutward/:id",
        element: /*#__PURE__*/ React.createElement(CreateBranchToBranchOutward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/branchToBranchOutward",
        element: /*#__PURE__*/ React.createElement(BranchToBranchOutward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createBranchToBranchOutward",
        element: /*#__PURE__*/ React.createElement(CreateBranchToBranchOutward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/workPurchaseOrder",
        element: /*#__PURE__*/ React.createElement(WorkPurchaseOrder, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createWorkPurchaseOrder",
        element: /*#__PURE__*/ React.createElement(CreateWorkPurchaseOrder, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/workPurchaseOrder/edit/:id",
        element: /*#__PURE__*/ React.createElement(CreateWorkPurchaseOrder, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/branchToBranchInward",
        element: /*#__PURE__*/ React.createElement(BranchToBranchInwardList, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createBranchToBranchInward",
        element: /*#__PURE__*/ React.createElement(CreateBranchToBranchInward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createBranchToBranchInward/:id",
        element: /*#__PURE__*/ React.createElement(CreateBranchToBranchInward, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/workPurchaseInvoice",
        element: /*#__PURE__*/ React.createElement(WorkPurchaseInvoice, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createWorkPurchaseInvoice",
        element: /*#__PURE__*/ React.createElement(CreateWorkPurchaseInvoice, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/pdicheck",
        element: /*#__PURE__*/ React.createElement(NewPDICheckPaging, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createWorkPurchaseInvoice/:id",
        element: /*#__PURE__*/ React.createElement(CreateWorkPurchaseInvoice, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/proprietaryWarranty",
        element: /*#__PURE__*/ React.createElement(ProprietaryWarranty, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/proprietaryWarranty/createProprietaryWarranty",
        element: /*#__PURE__*/ React.createElement(CreatePropritaryWarrantyIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/proprietaryWarranty/createProprietaryWarranty/:id",
        element: /*#__PURE__*/ React.createElement(CreatePropritaryWarrantyIndex, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createAppointment",
        element: /*#__PURE__*/ React.createElement(CreateAppointment, {
            view: "admin"
        })
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/sh",
        element: /*#__PURE__*/ React.createElement(ServiceHistory, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/crmdashboard",
        element: /*#__PURE__*/ React.createElement(CRMDashboard, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/crm/:id",
        element: /*#__PURE__*/ React.createElement(CrmCustomerProfile, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/appointment-detail",
        element: /*#__PURE__*/ React.createElement(AppointmentDetail, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/jobCardInvoicesReturn",
        element: /*#__PURE__*/ React.createElement(JciReturnNew, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/newJobCardInvoicesReturn",
        element: /*#__PURE__*/ React.createElement(JciReturnUpdate, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/fieldFailureReports",
        element: /*#__PURE__*/ React.createElement(FieldFailureReports, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/fieldFailureReports/:id",
        element: /*#__PURE__*/ React.createElement(EditFieldFailureReport, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/fieldFailureReports/create",
        element: /*#__PURE__*/ React.createElement(AddManualFieldFailureReport, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/areaFieldReports",
        element: /*#__PURE__*/ React.createElement(AreaFieldReports, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/areaFieldReports/ffr/:id",
        element: /*#__PURE__*/ React.createElement(FieldFailureReport, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/areaFieldReports/dashboard",
        element: /*#__PURE__*/ React.createElement(DashboardComp, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/areaFieldReports/ffr",
        element: /*#__PURE__*/ React.createElement(FFRCatalog, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/areaFieldReports/afr",
        element: /*#__PURE__*/ React.createElement(AreaFieldReportView, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/areaFieldReports/afr/:id",
        element: /*#__PURE__*/ React.createElement(AreaFieldReport, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/contractSaleOrder",
        element: /*#__PURE__*/ React.createElement(ContractSaleOrder, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createContractSaleOrder",
        element: /*#__PURE__*/ React.createElement(NewContractSaleOrder, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createContractSaleOrder/:id",
        element: /*#__PURE__*/ React.createElement(NewContractSaleOrder, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/contractSaleInvoice/",
        element: /*#__PURE__*/ React.createElement(ContractSaleinvoice, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createContractSaleInvoice/:id",
        element: /*#__PURE__*/ React.createElement(NewContractSaleInvoice, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createContractSaleInvoice",
        element: /*#__PURE__*/ React.createElement(NewContractSaleInvoice, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/FFrDashboard",
        element: /*#__PURE__*/ React.createElement(FFrDashboard, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/ASmDashboard",
        element: /*#__PURE__*/ React.createElement(AsmDashBoard, null)
    }), "************************************************* M2 & M3 Combined ************************************", /*#__PURE__*/ React.createElement(Route, {
        path: "/new-serviceEstimate-detail",
        element: /*#__PURE__*/ React.createElement(ServiceEstimateDetails, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/job-card-invoice",
        element: /*#__PURE__*/ React.createElement(ReadyForInvoiceList, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/jobCardInvoices",
        element: /*#__PURE__*/ React.createElement(JobCardInvoiceTabs, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/ready-for-invoice",
        element: /*#__PURE__*/ React.createElement(ReadyForInvoiceTab, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/account-posting-mobile",
        element: /*#__PURE__*/ React.createElement(AccountPostingMobile, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/Invoice-Tile",
        element: /*#__PURE__*/ React.createElement(InvoicedTab, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/create-invoice/:id",
        element: /*#__PURE__*/ React.createElement(CreateInvoice, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/contractSaleReturn",
        element: /*#__PURE__*/ React.createElement(ContractSaleReturn, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/CSR-Create",
        element: /*#__PURE__*/ React.createElement(ContractSalesReturnCreate, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/receivedAFRs",
        element: /*#__PURE__*/ React.createElement(ReceivedAFRs, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/psgDashboard",
        element: /*#__PURE__*/ React.createElement(PSGDashboard, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/utility",
        element: /*#__PURE__*/ React.createElement(UtilityCatalogView, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/receivedAFRs/:id",
        element: /*#__PURE__*/ React.createElement(EditAFR, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/iRs/editIR",
        element: /*#__PURE__*/ React.createElement(EditIR, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/iRs",
        element: /*#__PURE__*/ React.createElement(InvestigationReports, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/cqaDashboard",
        element: /*#__PURE__*/ React.createElement(CQADashboard, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/cqaIRs",
        element: /*#__PURE__*/ React.createElement(CQA_IRs, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/cqaCorrectiveActionPlanned",
        element: /*#__PURE__*/ React.createElement(CQACorrectiveActionPlanned, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/iRs/cqaReceivedEdit",
        element: /*#__PURE__*/ React.createElement(CQAReceivedEdit, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/vehicleHistory",
        element: /*#__PURE__*/ React.createElement(VehicleHistory, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createpdicheck",
        element: /*#__PURE__*/ React.createElement(CreateNewPDICheck, null)
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/createpdicheck/edit/:id",
        element: /*#__PURE__*/ React.createElement(CreateNewPDICheck, null)
    }))), window.location.hostname === 'localhost' ?
        /*#__PURE__*/
        // add all dev test routes in this block. these will be rendered in localhost only
        React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Route
        // path="/demo/*"
        // element={<TabLayout rootPath="/demo" />}
        , {
            element: /*#__PURE__*/ React.createElement(TabNavs
            // parentPath="/demo"
            , {
                routes: [{
                        id: 'Catalog',
                        path: 'catalog'
                    }, {
                        id: 'Form',
                        path: 'form'
                    }, {
                        id: 'Dialog',
                        path: 'dialog'
                    }, {
                        id: 'Renderer',
                        path: 'renderer'
                    }]
            })
        }, /*#__PURE__*/ React.createElement(Route, {
            path: "renderer",
            element: /*#__PURE__*/ React.createElement(JsonRenderer, null)
        }), /*#__PURE__*/ React.createElement(Route, {
            path: "catalog",
            element: /*#__PURE__*/ React.createElement(DemoCatalog, null)
        }), /*#__PURE__*/ React.createElement(Route, {
            path: "form",
            element: /*#__PURE__*/ React.createElement(DemoForm, null)
        }), /*#__PURE__*/ React.createElement(Route, {
            path: "dialog",
            element: /*#__PURE__*/ React.createElement(DialogDemo, null)
        })), /*#__PURE__*/ React.createElement(Route, {
            path: "/ready-for-invoice",
            element: /*#__PURE__*/ React.createElement(ReadyForInvoiceList, null)
        }), /*#__PURE__*/ React.createElement(Route, {
            path: "/ready-for-invoice-mobile",
            element: /*#__PURE__*/ React.createElement(ReadyForInvoiceMobile, null)
        }), /*#__PURE__*/ React.createElement(Route, {
            path: "/account-posting-mobile",
            element: /*#__PURE__*/ React.createElement(AccountPostingMobile, null)
        }), /*#__PURE__*/ React.createElement(Route, {
            path: "/Invoice-create",
            element: /*#__PURE__*/ React.createElement(CreateInvoice, null)
        }), /*#__PURE__*/ React.createElement(Route, {
            path: "/Invoice-Detalis",
            element: /*#__PURE__*/ React.createElement(PartInvoiceDetails, null)
        })) : null, /*#__PURE__*/ React.createElement(Route, {
        path: "/customerAppointment",
        element: /*#__PURE__*/ React.createElement(CreateAppointment, {
            view: "customer"
        })
    }));
}
export default AppRoutes;
